function pw_prepare_add_to_cart(){
  $(".pwAddToCart").prop("disabled", false).removeAttr("disabled").removeClass("disabled").show();
}

function pw_hide_add_to_cart(){
  $(".shopify-payment-button, .pwAddToCart").hide();
}

function pw_auto_add_to_cart_after_personalisation(personalisationID){
  if(!personalisationID || window.pwAutoAddAfterPersonalisation){ return; }
  window.pwAutoAddAfterPersonalisation = true;
  pw_prepare_add_to_cart();
  setTimeout(function(){
    var addButton = $(".pwAddToCart").first();
    if(addButton.length){ addButton.trigger("click"); }
    pw_hide_add_to_cart();
    setTimeout(pw_hide_add_to_cart, 500);
    setTimeout(pw_hide_add_to_cart, 1000);
    setTimeout(pw_hide_add_to_cart, 2000);
    setTimeout(pw_hide_add_to_cart, 4000);
  }, 700);
}

function pw_post_product_modal_save(personalisationID, thumbURL){
  imageZoomSwap(thumbURL);
  if(personalisationID){
    $("#pw_personalisation_id").val(personalisationID).trigger("change");
    pw_auto_add_to_cart_after_personalisation(personalisationID);
  }
}

function imageZoomSwap(thumbURL){
  $("#ProductPhoto-product-template img").attr("src", thumbURL);
  $("#ProductPhoto-product-template img").attr("srcset", thumbURL);
  $("#ProductPhoto-product-template img").attr("data-srcset", thumbURL);
  $("#ProductPhoto-product-template img").attr("data-src", thumbURL);
  $("#ProductPhoto-product-template img").attr("data-zoom", thumbURL);
}

function pw_make_next_button_edit(){
  var nextButton = document.getElementById("pwNextButton");
  var editButton = document.getElementById("pwEditCardButton");
  if(nextButton){
    nextButton.onclick = function(e){
      if(e){ e.preventDefault(); e.stopPropagation(); }
      if(typeof window.sE === "function"){ window.sE(); }
      else if(editButton){ editButton.click(); }
      return false;
    };
  }
}

function pw_keep_next_button_as_edit(){
  setInterval(pw_make_next_button_edit, 500);
}

function isBlankCardSelected() {
  if (typeof pwBlankVariantId === 'undefined') return false;
  var selected = $("select.pwProductSelect").val();
  if (!selected) selected = $(".swatch-container input:checked").val();
  return selected && parseInt(selected) === parseInt(pwBlankVariantId);
}

function pw_show_blank_cart_button() {
  if ($("#pw-blank-add-to-cart").length) {
    $("#pw-blank-add-to-cart").show();
    return;
  }
  var btn = $('<button type="button" id="pw-blank-add-to-cart" class="btn default-cart-button__button" style="width:100%;margin-top:10px;">Add to Cart</button>');

  // Insert in the same visual slot as the "Add a Message" button
  if ($("#pw_cart_button").length) {
    $("#pw_cart_button").after(btn);
  } else {
    $(".sending-options-wrapper").append(btn);
  }

  btn.on("click", function() {
    var orderID = (new Date().getTime()).toString(16) + Math.random().toString(36).slice(11);
    btn.prop("disabled", true).text("Adding...");

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        id: pwBlankVariantId,
        quantity: 1,
        properties: {
          "_pwStaticProduct": "1",
          "_pwOrderID": orderID
        }
      },
      dataType: "json",
      success: function(productData) {
        btn.prop("disabled", false).text("Add to Cart");
        $.getJSON("/cart.js", function(cartData) {
          if (window.StyleHatch && StyleHatch.AjaxCart) {
            StyleHatch.AjaxCart.updateCartButton(cartData);
          }
          var $util = $("header.util");
          var $cartPreview = $("header.util .cart-preview");
          if ($cartPreview.length) {
            clearTimeout(window.pwCartPreviewTimer);
            $cartPreview.hide();
            var totalPrice = typeof theme !== 'undefined' && theme.Currency
              ? theme.Currency.formatMoney(cartData.total_price, StyleHatch.currencyFormat)
              : '\u00a3' + (cartData.total_price / 100).toFixed(2);
            var productPrice = typeof theme !== 'undefined' && theme.Currency
              ? theme.Currency.formatMoney(productData.price, StyleHatch.currencyFormat)
              : '\u00a3' + (productData.price / 100).toFixed(2);
            var itemCount = cartData.item_count;
            var $productImage = $cartPreview.find('.product-image').empty();
            $productImage.append('<img src="' + productData.image + '" alt="' + productData.product_title + '">');
            $productImage.attr('href', productData.url);
            $cartPreview.find('.product-title').html(productData.product_title).attr('href', productData.url);
            var $productVariant = $cartPreview.find('.product-variant').empty();
            if (productData.variant_options) {
              $.each(productData.variant_options, function() {
                if (this.toString().toLowerCase().indexOf('default title') < 0) {
                  $productVariant.show().append('<li>' + this + '</li>');
                } else {
                  $productVariant.hide();
                }
              });
            }
            $cartPreview.find('.product-price').html('<strong><span class="money">' + productPrice + '</span></strong>');
            if (itemCount > 1) {
              $cartPreview.find('.count.plural').show();
              $cartPreview.find('.count.singular').hide();
            } else {
              $cartPreview.find('.count.plural').hide();
              $cartPreview.find('.count.singular').show();
            }
            $cartPreview.find('.total-price').html('<span class="money">' + totalPrice + '</span>');
            $cartPreview.css({ top: $util.height() });
            $cartPreview.fadeIn(300);
            window.pwCartPreviewTimer = setTimeout(function() {
              $cartPreview.fadeOut(300);
            }, 6000);
            $cartPreview.find('a.continue-shopping').off('click.pw').on('click.pw', function(e) {
              $cartPreview.fadeOut(300);
              e.preventDefault();
            });
          } else {
            window.location.href = '/cart';
          }
        });
      },
      error: function() {
        btn.prop("disabled", false).text("Add to Cart");
        alert("Sorry, something went wrong. Please try again.");
      }
    });
  });
}

function pw_hide_blank_cart_button() {
  $("#pw-blank-add-to-cart").hide();
}

function updateBlankCardUI() {
  if (typeof pwBlankVariantId === 'undefined') return;
  if (isBlankCardSelected()) {
    $("#pw_cart_button").hide();
    $(".blank-card-note").show();
    $(".default-cart-button").hide();
    $(".shopify-payment-button").hide();
    pw_show_blank_cart_button();
  } else {
    $("#pw_cart_button").show();
    $(".blank-card-note").hide();
    pw_hide_blank_cart_button();
    $(".default-cart-button").show();
    pw_hide_add_to_cart();
  }
}

function pw_init_sticky_nav() {
  if ($(window).width() < 700) return;

  var headerSection = document.getElementById('shopify-section-header');
  if (!headerSection) return;

  var sentinel = document.createElement('div');
  sentinel.id = 'pw-scroll-sentinel';
  sentinel.style.cssText = 'position:absolute; top:0; left:0; width:1px; height:1px; pointer-events:none;';
  headerSection.parentNode.insertBefore(sentinel, headerSection);

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting) {
        document.body.classList.add('nav-stuck');
      } else {
        document.body.classList.remove('nav-stuck');
      }
    });
  }, { threshold: 0 });

  observer.observe(sentinel);
}

$(document).ready(function() {

  pw_keep_next_button_as_edit();
  setTimeout(pw_init_sticky_nav, 300);

  var pw_button = $("#pw_cart_button");

  if ($("body").hasClass("template-product") && pw_button.length) {

    setTimeout(function(){
      if (typeof pwBlankVariantId !== 'undefined') {
        updateBlankCardUI();
      } else {
        pw_hide_add_to_cart();
      }
    }, 1000);

    $(document).on("change", ".selector-wrapper select", function(){
      if (typeof pwBlankVariantId !== 'undefined') {
        updateBlankCardUI();
      } else {
        pw_hide_add_to_cart();
      }
    });

    $(document).on("DOMSubtreeModified", "#pw_personalisation_id", function() {
      $("#pw_cart_button").val("Add a Message");
      if (window.pwAutoAddAfterPersonalisation) pw_hide_add_to_cart();
    });

    var targetNode = document.getElementById("pw_personalisation_id");
    if (targetNode) {
      var observer = new MutationObserver(function() {
        $("#pw_cart_button").val("Add a Message");
        if (window.pwAutoAddAfterPersonalisation) pw_hide_add_to_cart();
      });
      observer.observe(targetNode, { attributes: true, childList: true });
    }

    setTimeout(function(){
      if (typeof pwBlankVariantId !== 'undefined') {
        updateBlankCardUI();
      } else {
        pw_hide_add_to_cart();
      }
    }, 3000);

    $(document).on("click", ".swatch-container input", function(){
      window.pwAutoAddAfterPersonalisation = false;
      var product_image_original = $("a.card__image-container").attr("href");
      if (product_image_original) {
        $("#ProductPhoto-product-template img").attr("src", product_image_original);
        $("#ProductPhoto-product-template img").attr("data-src", product_image_original);
        $("#ProductPhoto-product-template img").attr("srcset", product_image_original);
        $("#ProductPhoto-product-template img").attr("data-zoom", product_image_original);
      }
      $("#pw_cart_button").val("Add a Message");
      setTimeout(function(){
        if (typeof pwBlankVariantId !== 'undefined') {
          updateBlankCardUI();
        } else {
          pw_hide_add_to_cart();
        }
      }, 1000);
    });
  }

  function replacePWimages(){
    var textArray = $(".cart-item .product-personalisation:contains('PersonalisationID')");
    textArray.each(function() {
      var cardID = this.innerText.match(/PersonalisationID:.*/);
      if (!cardID) return;
      cardID = cardID[0].replace("PersonalisationID:", "").trim().match(/[^\s]+/);
      if (!cardID) return;
      cardID = cardID[0];
      var rand = Math.floor(Math.random() * 10000);
      var newSrc = "https://shopify.printzware.com/thumbs/740/" + cardID + ".jpg?r=" + rand;
      $(this).parent().parent().find("img").attr("src", newSrc);
      $(this).parent().parent().find("img").attr("srcset", newSrc);
      $(this).parent().parent().find("img").attr("data-srcset", newSrc);
    });
  }

  $(".pwAddToCart").on("click", function(){
    setTimeout(function(){
      if ($("#pw_personalisation_id").length) {
        var cardID = $("#pw_personalisation_id").val();
        if (cardID) {
          var rand = Math.floor(Math.random() * 10000);
          var newSrc = "https://shopify.printzware.com/thumbs/740/" + cardID + ".jpg?r=" + rand;
          $(".cart-preview a.product-image img").attr("src", newSrc);
          $(".cart-preview a.product-image img").attr("srcset", newSrc);
        }
      }
      if (window.pwAutoAddAfterPersonalisation) pw_hide_add_to_cart();
    }, 1000);
  });

  if ($("body").hasClass("template-cart")) {
    replacePWimages();
    $(".remove").on("click", function() { setTimeout(replacePWimages, 2000); });
    $("#pw_modal").on("hidden.bs.modal", function() { setTimeout(replacePWimages, 1000); });
  }

});

(function(){
  function renamePrintzwareEditButton(){
    var editButton = document.getElementById("pwEditCardButton");
    if (editButton) {
      editButton.innerHTML = '<i class="fa fa-edit"> </i> <span class="btn_divider_center"></span><span id="editText">Add Message</span>';
      editButton.value = "Add Message";
    }
    setTimeout(renamePrintzwareEditButton, 1000);
  }
  renamePrintzwareEditButton();
})();
